import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import styles from "./RootLayout.module.css";

function RootLayout() {
  return (
    <div className={styles.app}>
      <Sidebar />
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}

const RootApp = () => (
    <RootLayout />
);

export default RootApp;
